export const formUtility = {
  methods: {
      getPhoneMask( phoneNumber ) {
          if(!phoneNumber) return phoneNumber
          phoneNumber = phoneNumber.replace(/[^0-9]/g, '')
      
          let res = ''
          if(phoneNumber.length < 3) {
              res = phoneNumber
          }
          else {
              if(phoneNumber.substr(0, 2) =='02') {            
                  if(phoneNumber.length <= 5) {//02-123-5678
                      res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3)
                  }
                  else if(phoneNumber.length > 5 && phoneNumber.length <= 9) {//02-123-5678
                      res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3) + '-' + phoneNumber.substr(5)
                  }
                  else if(phoneNumber.length > 9) {//02-1234-5678
                      res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 4) + '-' + phoneNumber.substr(6)
                  }
          
              } 
              else {
                  if(phoneNumber.length < 8) {
                      res = phoneNumber
                  }
                  else if(phoneNumber.length === 8)
                  {
                      res = phoneNumber.substr(0, 4) + '-' + phoneNumber.substr(4)
                  }
                  else if(phoneNumber.length === 9)
                  {
                      res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6)
                  }
                  else if(phoneNumber.length === 10)
                  {
                      res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6)
                  }
                  else if(phoneNumber.length > 10) { //010-1234-5678
                      res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 4) + '-' + phoneNumber.substr(7)
                  }
              }
          }
          return res;
      },    
      getPhoneState(len) {            
          if (len === 0) {
              return null;
          }
          else if (len === 13) {
              return true;
          }
          else {
              return false;
          }
      },
      numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },        
      dateFormat(d, f) {
        if (!d.valueOf()) return " ";
        var weekKorName = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
        var weekKorShortName = ["일", "월", "화", "수", "목", "금", "토"];
        var weekEngName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        var weekEngShortName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];        
    
        return f.replace(/(yyyy|yy|MM|dd|KS|KL|ES|EL|HH|hh|mm|ss|a\/p)/gi, function ($1) {
            switch ($1) {
                case "yyyy": return d.getFullYear(); // 년 (4자리)
                case "yy": return (d.getFullYear() % 1000).zf(2); // 년 (2자리)
                case "MM": return (d.getMonth() + 1).zf(2); // 월 (2자리)
                case "dd": return d.getDate().zf(2); // 일 (2자리)
                case "KS": return weekKorShortName[d.getDay()]; // 요일 (짧은 한글)
                case "KL": return weekKorName[d.getDay()]; // 요일 (긴 한글)
                case "ES": return weekEngShortName[d.getDay()]; // 요일 (짧은 영어)
                case "EL": return weekEngName[d.getDay()]; // 요일 (긴 영어)
                case "HH": return d.getHours().zf(2); // 시간 (24시간 기준, 2자리)
                // eslint-disable-next-line
                case "hh": return ((h = d.getHours() % 12) ? h : 12).zf(2); // 시간 (12시간 기준, 2자리)
                case "mm": return d.getMinutes().zf(2); // 분 (2자리)
                case "ss": return d.getSeconds().zf(2); // 초 (2자리)
                case "a/p": return d.getHours() < 12 ? "오전" : "오후"; // 오전/오후 구분
                default: return $1;
            }
        });
      }      
  }
}